module.exports = __webpack_public_path__ + "34bc775d/img/grid-web-icon.d0395d64.svg";